/**
 * Component Registry for Weidner Apartment Homes Theme
 * 
 * Extends the base belmont theme registry with Weidner Apartment Homes specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-belmont/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Footer } from './components/Footer';
import { GalleryApartments } from './components/GalleryApartments';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';
import { CortLeadFormCta } from './components/CortLeadFormCta';
import { Deals } from './components/Deals';
import { DallasMavericksGames } from './components/DallasMavericksGames';
import { QualifyingCriteria } from './components/QualifyingCriteria';
import { AmenitiesList } from './components/AmenitiesList';
import { FloorPlansIntro } from './components/FloorPlansIntro';
import { PropertyOverview } from './components/PropertyOverview';
import { PinnedCallouts } from './components/PinnedCallouts';
import { NeighborhoodShowcase } from './components/NeighborhoodShowcase';
import { HeroSolidBG } from './components/HeroSolidBG';
import { FutureResidentsClub } from './components/FutureResidentsClub';
import { SpecialOffers } from './components/SpecialOffers';
import { PetPolicy } from './components/PetPolicy';
import { ReviewsCallout } from './components/ReviewsCallout';
import { ThankYouContent } from './components/ThankYouContent';
import { ResidentAccess } from './components/ResidentAccess';
import { ApplyNow } from './components/ApplyNow';

/**
 * Weidner Apartment Homes specific component overrides.
 * These components have been customized for the Weidner Apartment Homes brand.
 */
const weidnerapartmenthomesOverrides: Partial<ComponentRegistry> = {
  Header,
  Hero,
  Footer,
  GalleryApartments,
  VirtualTourEmbed,
  CortLeadFormCta,
  Deals,
  DallasMavericksGames,
  QualifyingCriteria,
  AmenitiesList,
  FloorPlansIntro,
  PropertyOverview,
  PinnedCallouts,
  NeighborhoodShowcase,
  HeroSolidBG,
  FutureResidentsClub,
  SpecialOffers,
  PetPolicy,
  ReviewsCallout,
  ThankYouContent,
  ResidentAccess,
  ApplyNow,
};

/**
 * Final merged registry for Weidner Apartment Homes properties.
 * Inherits all components from the belmont theme, with Weidner Apartment Homes overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...weidnerapartmenthomesOverrides,
};

export default registry;
